
export * from "./Recognizer";
export * from "./SpeechConnectionFactory";



// WEBPACK FOOTER //
// ./~/microsoft-speech-browser-sdk-cris/src/sdk/speech.browser/Exports.ts